import './Footer.css';
import { FiYoutube } from 'react-icons/fi';
import { FaVrCardboard } from 'react-icons/fa';
// import { TiWiFi } from 'react-icons/ti';
import { TiWiFi } from 'react-icons/ti';
import { FiPhoneCall } from 'react-icons/fi';
import { BsWhatsapp } from 'react-icons/bs';
import { AiOutlineMail } from 'react-icons/ai';

const Footer = () => {
  return (
    <>
      <div className="content ">
        <h1>Enjoy your Student Life & Excel at SRM</h1>
        <div className="links">
          <div className="pair">
            <div className="part">
              <h3>Campuses</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Kattankulathur (KTR) - Chennai</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://srmrmp.edu.in/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Ramapuram - Chennai</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="http://www1.srmist.edu.in/vadapalani/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Vadapalani - Chennai</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://ist.srmtrichy.edu.in/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Tiruchirappalli </span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmup.in/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Delhi - NCR</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://srmap.edu.in/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">SRM University - AP (Andhra Pradesh)</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://srmuniversity.ac.in/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">SRM University - Haryana</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://srmus.ac.in/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">SRM University - Sikkim</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="part">
              <h3>Colleges @ SRMIST KTR</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/college/college-of-engineering-technology/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Engineering &amp; Technology</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/college/medicine-and-health-sciences/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Medical &amp; Health Sciences</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/college/college-of-management/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Management</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/college/college-of-science-and-humanities/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Science &amp; Humanities</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/department/institute-of-hotel-and-catering-management/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Hotel Management</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/college/college-of-law/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Law</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/college/srm-college-of-agriculture-sciences/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Agricultural Sciences</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://srmistdistanceeducation.in/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Distance Education</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmonline.in/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Online Education</span>
                  </a>
                </li>
              </ul>
              <h3>
                <a href="https://www.srmist.edu.in/life-at-srm/" target="_blank" rel="noreferrer">
                  Campus Life
                </a>
              </h3>
            </div>
          </div>
          <div className="pair">
            <div className="part">
              <h3>A to Z - Quicklinks</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/departments/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Departments</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/program-finder/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Programs</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/staff-finder/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Staff/Faculty Search</span>
                  </a>
                </li>
              </ul>
              <h3>Access For</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/students/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Students</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/faculty-gateway/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Faculty &amp; Staffs</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://alumni.srmist.edu.in/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Alumni</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/parents/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Parents</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="part">
              <h3>Insights</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/research/innovation-incubation/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Innovation &amp; Incubation Center</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/life-at-srm/student-life/clubs/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Student Clubs</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://srmuniv.researgence.com/" target="_blank" rel="noreferrer">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Researgence</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/spectrum/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Spectrum</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/iqac/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Internal Quality Assurance Cell</span>
                  </a>
                </li>
              </ul>
              <h3>Visitors</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://webstor.srmist.edu.in/web_assets/srmist-virtual-tour-vo/index.htm">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Campus Tour</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/visitors/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">How to Reach</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="part">
              <h3>Admissions & Aid</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/admission-india/engineering/scholarships/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Scholarships</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/admission-india/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Admission India</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/admission-international/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Admission International </span>
                  </a>
                </li>
              </ul>
              <h3>Media & Resources</h3>
              <ul className="elementor-icon-list-items">
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/news/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Press &amp; Media</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/events/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Events</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/life-at-srm/complaints-redressal/womens-grievance-redressal-committee/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Grievances </span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a href="https://www.srmist.edu.in/policies/">
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Policies</span>
                  </a>
                </li>
                <li className="elementor-icon-list-item">
                  <a
                    href="https://webstor.srmist.edu.in/web_assets/downloads/2021/srmist-mandatory-disclosure-28Apr21.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="elementor-icon-list-icon"></span>
                    <span className="elementor-icon-list-text">Mandatory Disclosures</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="lowerFooter">
        <div className="inner1">
          <img src="https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2022/01/srm-logo.svg" alt=""></img>
        </div>
        <div className="inner2">
          <div
            className="cont"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5vw',
              paddingBottom: '1vh',
              color: '#f99979',
            }}
          >
            <FiPhoneCall style={{ fontSize: '5vh' }} />
            <p style={{ margin: '0', color: '#f99979', fontSize: '3vh' }}><a href='tel:+914427417000'>+91 4427417000</a></p>
          </div>
          <div
            className="cont"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5vw',
              paddingBottom: '1vh',
            }}
          >
            <BsWhatsapp style={{ fontSize: '5vh', color: '#f99979' }} />
            <p style={{ margin: '0', color: '#f99979', fontSize: '3vh' }}>+91 4427417499</p>
          </div>
          <div
            className="cont"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5vw',
              paddingBottom: '1vh',
            }}
          >
            <AiOutlineMail style={{ fontSize: '5vh', color: '#f99979' }} />
            <p style={{ margin: '0', color: '#f99979', fontSize: '3vh' }}><a href="mailto:infodesk@srmist.edu.in">infodesk@srmist.edu.in</a></p>
          </div>
        </div>
        <div className="inner3">
          <div className="rightinner">
            <a
              href="https://webstor.srmist.edu.in/web_assets/srmist-virtual-tour-vo/index.htm"
              className="linkstoinner"
            >
              <FaVrCardboard />
              <p>Virtual Tour</p>
            </a>
            <a href="https://www.youtube.com/user/SRMeducation" className="linkstoinner">
              <FiYoutube />
              <p>Videos</p>
            </a>
            <a href="https://www.srmist.edu.in/life-at-srm/muthucharam/" className="linkstoinner">
              <TiWiFi />
              <p>Community Radio</p>
            </a>
          </div>
          {/* <div className="rightinner2">
            <input className='input-footer' placeholder="Email or Mobile Number" type="search" name="search" />
            <button type="submit">STAY IN TOUCH</button>
          </div> */}
        </div>
      </div>
      <footer className="footerFooter">
        <div className="terms">
          <h4 style={{ cursor: 'pointer' }}>
            <a target="_blank" href="https://www.srmist.edu.in/terms-and-conditions/" rel="noreferrer">
              Terms of Use
            </a>
          </h4>
          <h4 style={{ cursor: 'pointer' }}>
            <a target="_blank" href="https://www.srmist.edu.in/privacy-policy/" rel="noreferrer">
              Privacy Policy
            </a>
          </h4>
        </div>
        <div className="copy">
          <h4>Copyrights All Rights Reserved</h4>
        </div>
        {/* <div className="iconsfootfinal">icons</div> */}
      </footer>
    </>
  );
};

export default Footer;
